module.exports = __webpack_public_path__ + "img/1515067905.9d81cab4.jpg";